import dayjs, { type Dayjs } from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(quarterOfYear);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);

export type ShortcutKey =
  | "thisWeek"
  | "lastWeek"
  | "thisMonth"
  | "lastMonth"
  | "thisQuarter"
  | "lastQuarter"
  | "last30Days"
  | "thisYear"
  | "lastYear"
  | "custom";

export interface ShortcutDefinition {
  key: ShortcutKey;
  labelKey: string;
  getValue: () => [Dayjs | null, Dayjs | null];
}

export const SHORTCUT_DEFINITIONS: ShortcutDefinition[] = [
  {
    key: "thisWeek",
    labelKey: "common.dateRange.thisWeek",
    getValue: () => [
      // Week starts on Monday (ISO week). To change, use .startOf("week") with locale config
      dayjs().startOf("isoWeek"),
      dayjs().endOf("isoWeek"),
    ],
  },
  {
    key: "lastWeek",
    labelKey: "common.dateRange.lastWeek",
    getValue: () => [dayjs().subtract(1, "week").startOf("isoWeek"), dayjs().subtract(1, "week").endOf("isoWeek")],
  },
  {
    key: "last30Days",
    labelKey: "common.dateRange.last30Days",
    getValue: () => [dayjs().subtract(30, "day"), dayjs()],
  },
  {
    key: "thisMonth",
    labelKey: "common.dateRange.thisMonth",
    getValue: () => [dayjs().startOf("month"), dayjs().endOf("month")],
  },
  {
    key: "lastMonth",
    labelKey: "common.dateRange.lastMonth",
    getValue: () => [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")],
  },
  {
    key: "thisQuarter",
    labelKey: "common.dateRange.thisQuarter",
    getValue: () => [dayjs().startOf("quarter"), dayjs().endOf("quarter")],
  },
  {
    key: "lastQuarter",
    labelKey: "common.dateRange.lastQuarter",
    getValue: () => [
      dayjs().subtract(1, "quarter").startOf("quarter"),
      dayjs().subtract(1, "quarter").endOf("quarter"),
    ],
  },
  {
    key: "thisYear",
    labelKey: "common.dateRange.thisYear",
    getValue: () => [dayjs().startOf("year"), dayjs().endOf("year")],
  },
  {
    key: "lastYear",
    labelKey: "common.dateRange.lastYear",
    getValue: () => [dayjs().subtract(1, "year").startOf("year"), dayjs().subtract(1, "year").endOf("year")],
  },
  // {
  //   key: "custom",
  //   labelKey: "common.dateRange.custom",
  //   getValue: () => [null, null],
  // },
];

export const getShortcutByKey = (key: ShortcutKey): ShortcutDefinition | undefined => {
  return SHORTCUT_DEFINITIONS.find((s) => s.key === key);
};

export const getShortcutLabel = (key: ShortcutKey, t: (key: string) => string): string => {
  const shortcut = getShortcutByKey(key);
  return shortcut ? t(shortcut.labelKey) : "";
};
